import React from "react";

export const PointIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none">
    <circle cx="16" cy="16" r="6" />
  </svg>
);
